import { useRef } from "react";
import { useSelector } from 'react-redux';
import IAppStore from 'app/IAppStore';
import { useBooleanUserPreference } from "features/userPreferences/useUserPreference";

export interface DrawerState {
    isShowing: boolean;
    isSearchFocused: boolean;
    expand(options?: ShowDrawerOptions): void;
    collapse(): void;
    toggle(options?: ShowDrawerOptions): void;
}

export interface ShowDrawerOptions {
    focusSearch?: boolean;
}

const Drawer_Expanded: string = 'Drawer_Expanded';

export default function useDrawer(): DrawerState {
    const isCustomer = useSelector((m: IAppStore) => m.userState.isCustomer);

    const drawerExpanded = useBooleanUserPreference(Drawer_Expanded, null)

    const isSearchFocused = useRef(false);

    //First time logging in, show the drawer to a customer
    const isExpanded = drawerExpanded.value || (drawerExpanded.value == null && isCustomer);

    function expand(options?: ShowDrawerOptions): void {
        if (options?.focusSearch) {
            isSearchFocused.current = true;
        }
        drawerExpanded.update(true);
    } 

    function collapse(): void {
        drawerExpanded.update(false);
        isSearchFocused.current = false;
    }

    function toggle(options?: ShowDrawerOptions): void {
        isExpanded ? collapse() : expand(options);
    }

    return {
        isShowing: isExpanded,
        isSearchFocused: isSearchFocused.current,
        expand,
        collapse,
        toggle
    }
}
